<div class="full-page">
  <img class="shared-login-banner" draggable="false" src="assets/images/grizzlies-maintenance-logo.png" />
  <div class="content">
    <img class="logo mb-3" draggable="false" src="assets/images/grizzly-logo.png" />

    <div class="text-center title">
      {{ 'maintenancepage.currentlyunavailable.title' | translate }}
    </div>
    <div class="maintenance-text" [innerHTML]="'maintenancepage.currentlyunavailable.text' | translate | markdownTranslate"></div>
  </div>
</div>
